import { Typography } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { StyledBox, StyledIcon } from './styles';

interface StepIconProps {
  isSelected: boolean;
  isCompleted: boolean;
  stepNumber: number;
}

export function StepIcon({
  isSelected,
  isCompleted,
  stepNumber,
}: Readonly<StepIconProps>) {
  if (isCompleted) {
    return (
      <StyledBox>
        <Icon
          name="actions-b2b-check-circle-filled"
          color={NEW_COLORS.SEMANTICS.SUCCESS[500]}
          size={38}
        />
      </StyledBox>
    );
  }

  return (
    <StyledIcon active={isSelected}>
      <Typography>{stepNumber}</Typography>
    </StyledIcon>
  );
}
